
import React, { useContext, useEffect, useState } from 'react';
import RatioButton from '../../subComponents/gacha/RatioButton'
import PurchaseButton from '../../subComponents/gacha/PurchaseButton'
import AuthContext from '../../utils/auth/AuthContext';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import LoadingScreen from '../loading/LoadingScreen';
import { preloadEffectVideo, PRELOAD_VIDEO_NAME } from '../../utils/media/videoPreload';

// 商品画像の onLoad が(キャッシュ済みなどで)発火しない場合の保険
const PRELOAD_FALLBACK_MS = 2500;
type PlayBeforeProps = {
  teamColor: string,
  tickets: number,
  teamName: string,
  product_code: string,
  setProductValiationId: React.Dispatch<React.SetStateAction<string>>,
  setRarityName: React.Dispatch<React.SetStateAction<string>>,
  setRarityGroup: React.Dispatch<React.SetStateAction<string>>,
  setProductValiationName: React.Dispatch<React.SetStateAction<string>>,
  setRareEffect: React.Dispatch<React.SetStateAction<string>>,
  setVideoName: React.Dispatch<React.SetStateAction<string>>,
  setTickets: React.Dispatch<React.SetStateAction<number>>;
}

export const PlayBefore: React.FC<PlayBeforeProps> = ({ teamColor, tickets, teamName, product_code, setProductValiationId, setRarityName, setRarityGroup, setProductValiationName, setRareEffect, setVideoName, setTickets }) => {
  const { authentication } = useContext(AuthContext);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [])

  // 購入前に演出動画を先読みしておく。ガチャを引けないユーザー(未ログイン・
  // チケット0枚)には無駄な通信になるので行わない。
  const canPlay = authentication && Number(tickets) > 0;

  // 商品画像は表示中のコンテンツなので、その読み込みが終わってから先読みを始める。
  // 同時に走らせると見ている画面の表示が遅くなる。
  const startVideoPreload = () => {
    if (canPlay) {
      preloadEffectVideo(PRELOAD_VIDEO_NAME);
    }
  };

  useEffect(() => {
    if (!canPlay) return;
    const timer = setTimeout(startVideoPreload, PRELOAD_FALLBACK_MS);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canPlay]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <div className='mainSection'>
        {windowWidth >= 500 ?
          <img className='mx-auto d-block w-100' src={`/image/${teamName}/${product_code}/product.jpg`} alt="product" onLoad={startVideoPreload} />
          :
          <img className='mx-auto d-block w-100' src={`/image/${teamName}/${product_code}/product-sm.jpg`} alt="product-sm" onLoad={startVideoPreload} />
        }
      </div>
      <div className="bg-cleargray p-2">
        <p className="fs-caption m-2 text-danger text-center">
          カードの保存期間は獲得から90日です。90日を過ぎた保有カードについては、発送の保証ができかねますのでご了承をお願いいたします。
        </p>
        <div className="w-250 bg-white text-center py-0 px-2 mx-auto border rounded-pill shadow">
          {
            Number(tickets) > 0 ?
              (
                authentication ?
                  <>
                    <span>所持チケット：{tickets}</span>
                    <PurchaseButton
                      teamColor={teamColor}
                      product_code={product_code}
                      setProductValiationId={setProductValiationId}
                      setProductValiationName={setProductValiationName}
                      setRarityName={setRarityName}
                      setRarityGroup={setRarityGroup}
                      setRareEffect={setRareEffect}
                      setVideoName={setVideoName}
                      setTickets={setTickets}
                      setLoading={setLoading}
                    />
                  </>
                  :
                  <>
                    <Button variant="primary" href="/login" className={`bg-${teamColor}-primary w-75 mx-auto m-2`}>購入する</Button>
                  </>
              )
              :
              (
                authentication ?
                  <>
                    <span className="text-danger fw-bold">所持チケット：{tickets}</span>
                    <Link className={`bg-${teamColor}-primary text-white btn w-75 mx-auto mt-4 px-2 py-1`} to="/ticket">チケットを購入する</Link>
                  </>
                  :
                  <>
                    <Button variant="primary" href="/login" className={`bg-${teamColor}-primary w-75 mx-auto m-2`}>購入する</Button>
                  </>
              )
          }
          <RatioButton teamColor={teamColor} product_code={product_code} />
          <p className="text-center"><Link to="/transaction">特定商取引法に基づく表記</Link></p>
        </div>
      </div>
    </>
  );
}

export default PlayBefore;
